import { InjectionToken } from "@angular/core";
export var CURRENCY_MASK_CONFIG = new InjectionToken("currency.mask.config");
//# sourceMappingURL=currency-mask.config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/micro/Downloads/Proyectos/PagosContabilidadUriel/~/ngx-currency/src/currency-mask.config.js
// module id = ../../../../ngx-currency/src/currency-mask.config.js
// module chunks = 3